import { jsx as _jsx } from "react/jsx-runtime";
import { ScopeContext } from '#pplx/frontend/framework/instrumentation/internal/ScopeContext.js';
/**
 * Re-injects a captured `ScopeNode` as the value of `ScopeContext` for its
 * descendants, without contributing a name segment to the dotted event name.
 *
 * Used to transplant a scope chain captured at one React tree position
 * (typically via `useInstrumentationParentScope()`) into a subtree that
 * renders elsewhere — most notably, modal content that mounts at a global
 * renderer outside the caller's tree.
 *
 * Composes with `<InstrumentationScope>`: a named scope mounted as a child
 * of this component will have `parent` as its parent in the merged chain.
 *
 * @see useInstrumentationParentScope
 */
export function InstrumentationInheritedScope({ parent, children, }) {
    return _jsx(ScopeContext.Provider, { value: parent, children: children });
}
//# sourceMappingURL=InstrumentationInheritedScope.js.map